'use client'
import { useState, useEffect } from 'react'
import { PrismicRichText } from '@prismicio/react'
import Cookies from 'js-cookie'
import CloseButton  from '../assets/images/icons/close-button.svg'

interface AlertBannerProps {
  core?: any | null;
}

const AlertBanner:React.FC<AlertBannerProps>  =({ core })=> {

  let searchAssets =[] as any
  core.data.slices.map((slice: any) => {
      if(slice.slice_type==="alert_banner") {
          searchAssets = slice;
      }
      return null;
  })

  const [alertState, setAlertState] = useState(searchAssets.primary.alert);

  useEffect(()=>{
      if(Cookies.get('alert') && Cookies.get('alert') !== "false") {
        setAlertState(true)
      } else { setAlertState(false) }
  },[])

  if(alertState) {
    return (
      <div className={"p-4 font-fellix " + alertState + " " + searchAssets.primary.alert_style.toLowerCase()}>
        <div className="text-white flex justify-between  max-w-[1280px] mx-auto">
          <PrismicRichText field={searchAssets.primary.alert_text}/>
          <div className="close-button"  onClick={()=>setAlertState(false)}><CloseButton/></div>
        </div>
      </div>
    )
  } else return null
}

export default AlertBanner;
